<template>
    <transition
        enter-from-class="translate-y-full"
        enter-active-class="transition-transform duration-300"
        enter-to-class="translate-y-0"
        leave-from-class="translate-y-0"
        leave-active-class="transition-transform duration-300"
        leave-to-class="translate-y-full"
    >
        <div
            :class="[
                collapsed ? 'h-12' : '',
                'max-w-[calc(100vw-1.5rem)] w-[25rem] lg:w-[30rem]',
                'bg-gray-100 rounded-lg shadow-origin-xl',
                'pointer-events-auto overflow-hidden',
                'transition-all duration-300',
            ]"
            :style="drawerHeight ? { height: drawerHeight } : {}"
            data-testid="slide-over-container"
            v-show="showing"
        >
            <add-lead
                :visible="!collapsed"
                @close="hide({ name: type })"
                v-model:collapsed="collapsed"
                v-if="type === 'addLead'"
            />
            <inter-account-leads
                @close="hide({ name: type })"
                v-model:collapsed="collapsed"
                v-if="type === 'interAccountLeads' && showing"
            />
            <sms-conversation-drawer
                :collapsed="collapsed"
                @update:collapsed="collapsed = $event"
                v-if="type === 'smsConversation'"
            />
        </div>
    </transition>
</template>

<script>
    import { mapActions, mapState } from 'pinia';
    import { useInterAccountLeadsStore } from '@/store/modules/interAccountLeads/store.js';
    import { useLayoutStore } from '@/store/modules/layout/store.js';
    import { useEventBus } from '@/hooks/useEventBus.ts';

    import AddLead from '@/components/add_lead/AddLead.vue';
    import InterAccountLeads from '@/components/inter_account_leads/InterAccountLeads.vue';
    import SmsConversationDrawer from '@/components/sms/SmsConversationDrawer.vue';

    const { on, off } = useEventBus();

    export default {
        components: {
            AddLead,
            InterAccountLeads,
            SmsConversationDrawer,
        },

        props: {
            type: {
                type: String,
                required: true,
            },
        },

        data: () => ({
            collapsed: false,
            showing: false,
        }),

        computed: {
            ...mapState(useLayoutStore, ['headerHeight', 'bodySpacingTop']),

            drawerHeight() {
                if (this.collapsed) {
                    return null;
                }

                const offset = this.headerHeight + this.bodySpacingTop;

                // 3rem = sticky bottom-6 (1.5rem) + content area md:p-6 (1.5rem)
                return `calc(100vh - ${offset}px - 3rem)`;
            },
        },

        methods: {
            ...mapActions(useInterAccountLeadsStore, ['setInterAccountLeadsOpened']),

            show(payload) {
                // Handle both formats: string (legacy) or { name, data } (new)
                const type = typeof payload === 'string' ? payload : payload.name;

                if (!type || type !== this.type) {
                    return;
                }

                if (this.type === 'interAccountLeads') {
                    this.setInterAccountLeadsOpened(true);
                }

                this.collapsed = false;
                this.showing = true;
            },

            hide({ name } = {}) {
                if (!name || name !== this.type) {
                    return;
                }

                if (this.type === 'interAccountLeads') {
                    this.setInterAccountLeadsOpened(false);
                }

                this.showing = false;
            },
        },

        created() {
            on('show-right-sidebar', this.show);
            on('hide-right-sidebar', this.hide);
        },

        beforeUnmount() {
            off('show-right-sidebar', this.show);
            off('hide-right-sidebar', this.hide);
        },
    };
</script>
